"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

/* eslint-disable */
var _default = /*#__PURE__*/React.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0, 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.6521 3.36956H2.69574C1.95165 3.36956 1.34775 2.76565 1.34775 2.02182C1.34775 1.27773 1.95165 0.673826 2.69574 0.673826H29.6521C30.3962 0.673826 31.0001 1.27773 31.0001 2.02182C31.0001 2.76565 30.3962 3.36956 29.6521 3.36956Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6521 10.1088H3.17392C2.42983 10.1088 1.82617 9.50487 1.82617 8.76078C1.82617 8.01695 2.42983 7.41304 3.17392 7.41304H16.6521C17.3962 7.41304 18.0001 8.01695 18.0001 8.76078C18.0001 9.50487 17.3962 10.1088 16.6521 10.1088Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6521 16.8477H3.17392C2.42983 16.8477 1.82617 16.2441 1.82617 15.5C1.82617 14.7559 2.42983 14.1523 3.17392 14.1523H16.6521C17.3962 14.1523 18.0001 14.7559 18.0001 15.5C18.0001 16.2441 17.3962 16.8477 16.6521 16.8477Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6521 23.587H3.17392C2.42983 23.587 1.82617 22.9831 1.82617 22.2392C1.82617 21.4951 2.42983 20.8912 3.17392 20.8912H16.6521C17.3962 20.8912 18.0001 21.4951 18.0001 22.2392C18.0001 22.9831 17.3962 23.587 16.6521 23.587Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6521 30.3262H2.69574C1.95165 30.3262 1.34775 29.7223 1.34775 28.9782C1.34775 28.2343 1.95165 27.6304 2.69574 27.6304H29.6521C30.3962 27.6304 31.0001 28.2343 31.0001 28.9782C31.0001 29.7223 30.3962 30.3262 29.6521 30.3262Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.3221 16.2419L24.0395 20.6222C24.3347 20.8959 24.7634 20.966 25.1326 20.8083C25.5006 20.6479 25.7392 20.2839 25.7392 19.8809L25.7392 16.8482L29.7827 16.8482C30.528 16.8482 31.1304 16.2446 31.1304 15.5005C31.1304 14.7564 30.528 14.1528 29.7827 14.1528L25.7392 14.1528L25.7392 11.1201C25.7392 10.7184 25.5006 10.3546 25.1326 10.1927C25.0018 10.1374 24.8658 10.1093 24.7283 10.1093C24.4776 10.1093 24.2308 10.2021 24.0395 10.3788L19.3221 14.7591C19.1172 14.9519 19 15.2201 19 15.5005C19 15.7809 19.1172 16.0504 19.3221 16.2419Z",
  fill: "black"
})));

exports["default"] = _default;
//# sourceMappingURL=indentRight.js.map